<template>
  <div class="business">
    <List :list="businessData" :titleHref="'/business'" />
    <Pagination @pageNumber="pageBtn" :pageSize="pageSize" :count="count"></Pagination>
  </div>
</template>
<script>
import List from '@/components/list';
import { businessJson } from '@/json/list';
import Pagination from '../components/pagination';

export default {
  name:'business',
  data() {
    return {
      count: businessJson.length,
      businessData: businessJson,
      pageSize: 12,
    }
  },
  methods:{
    pageBtn(i,maxLength){
      this.businessData = [];
      businessJson.map((item,index) => {
        if(index < maxLength && index >= i)
          this.businessData.push(item)
      })
    }
  },
  components:{
    List,
    Pagination,
  },
}
</script>
<style lang="scss" scoped>
    @import '@/style/variables.scss';
  .business{
    width:$navWidth;
    margin:20px auto 40px;
    border-radius: 5px;
  }
</style>
